export default function getTypewriterStrings({ animatedTextItems }) {
  return animatedTextItems.map((item) => {
    return `<span style="color: ${item.textColor?.color};">${item.text}</span>`;
  });
}
